const content = {
  coverage_table: [
    {
      align: "start",
      text: "Seq. No",
      value: "seq_num",
      of_type: "text",
    },
    {
      text: "M. Time",
      value: "time",
      of_type: "date",
    },
    {
      text: "LQI",
      value: "lqi",
      of_type: "text",
    },
    {
      text: "Base Station Reception Attributes",
      value: "rinfo",
      of_type: "object",
      values: {
        basestation_id: "Station",
        rssi: "RSSI(dBm)",
        snr: "SNR(dB)",
      },
    },
  ],
  //tabs: ["Serial Number"],
  tabs: [
    {
      value: "SerialNumber",
      label: "Serial Number",
    },
  ],
};
export { content };
